import { useState } from "react";
import { comics } from "@/mocks/comics";

const tabs = [
  { key: "hot", label: "人气榜", icon: "ri-fire-fill" },
  { key: "collect", label: "收藏榜", icon: "ri-bookmark-fill" },
  { key: "new", label: "新作榜", icon: "ri-sparkling-2-fill" },
];

const newComics = ["xinghai-huixiang", "mitang-weiji", "jingling-tiandianwu", "guiying-zhentanshe", "dushi-juexing"];

const rankColors = ["bg-secondary-400", "bg-foreground-300", "bg-accent-300"];

export default function Ranking() {
  const [active, setActive] = useState("hot");

  const list = (() => {
    if (active === "hot") return [...comics].sort((a, b) => b.heat - a.heat).slice(0, 5);
    if (active === "collect")
      return [...comics].sort((a, b) => b.rating - a.rating).slice(0, 5);
    return newComics
      .map((id) => comics.find((c) => c.id === id)!)
      .filter(Boolean)
      .slice(0, 5);
  })();

  return (
    <section id="rank" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm font-semibold text-secondary-800">
              <i className="ri-trophy-line"></i> 热门榜单
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">本周人气 TOP 5</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              榜单综合人气、收藏与完读率每 4 小时自动刷新，带你快速锁定本周最值得追的人气连载作品。
            </p>
          </div>

          <div className="flex rounded-full bg-background-100 p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActive(tab.key)}
                className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                  active === tab.key
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:text-primary-600"
                }`}
              >
                <i className={`${tab.icon} text-sm`}></i>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-2">
          {list.map((comic, idx) => (
            <article
              key={comic.id}
              className="flex items-center gap-4 rounded-2xl bg-background-50 p-4 transition-shadow hover:shadow-md"
            >
              <div className="relative flex w-10 shrink-0 flex-col items-center">
                <span
                  className={`font-heading text-3xl ${
                    idx < 3 ? rankColors[idx] : "text-foreground-200"
                  }`}
                >
                  {idx + 1}
                </span>
                {idx === 0 && <i className="ri-vip-crown-fill mt-1 text-secondary-500"></i>}
              </div>

              <div className="h-24 w-16 shrink-0 overflow-hidden rounded-lg">
                <img
                  src={comic.cover}
                  alt={`${comic.title} 人气连载漫画封面`}
                  className="h-full w-full object-cover"
                />
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="truncate text-base font-bold text-foreground-950">{comic.title}</h3>
                  <span className="shrink-0 rounded-md bg-background-100 px-1.5 py-0.5 text-xs text-foreground-500">
                    {comic.updateDay}
                  </span>
                </div>
                <p className="mt-1 truncate text-xs text-foreground-500">{comic.author} · {comic.genres.join(" / ")}</p>
                <div className="mt-2 flex items-center gap-4 text-xs text-foreground-600">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-secondary-500"></i> {comic.rating}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {comic.views}
                  </span>
                  <span className="hidden items-center gap-1 sm:flex">
                    <i className="ri-arrow-up-line text-primary-500"></i> 人气 {comic.heat}
                  </span>
                </div>
              </div>

              <a
                href="#updates"
                className="shrink-0 whitespace-nowrap rounded-lg bg-background-100 px-4 py-2 text-sm font-semibold text-primary-600 transition-colors hover:bg-primary-500 hover:text-background-50"
              >
                去追更
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}